import Panel from '../../apricot/Panel';
import Link from '../Link';
import styles from '../../../../sass/status.module.scss';
import { formatDateTime } from '../../../date';
export default (function (props) {
  var allowedToOrder = props.allowedToOrder,
      subOrderProcessing = props.subOrderProcessing,
      orderStatus = props.orderStatus,
      changeOrderStatus = props.changeOrderStatus,
      history = props.history;
  var hasUnsubmittedChanges = changeOrderStatus === 'NOT_SUBMITTED';
  var isSubmitted = orderStatus === 'SUBMITTED';

  var PanelHeader = function PanelHeader() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !allowedToOrder ? /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-exclamation ".concat(styles['order-alert-icon'])
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Please complete the participation form")) : null, "Orders");
  };

  var SubmitOrderLink = function SubmitOrderLink(_ref) {
    var path = _ref.path;
    return /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: path,
      className: "".concat(allowedToOrder ? '' : 'disabled', " btn btn-sm btn-primary")
    }, "Review & Submit Order");
  };

  var ShipmentsLink = function ShipmentsLink() {
    return subOrderProcessing ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/orders/shipments"
    }, "View Shipments ", /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-east"
    }))) : null;
  };

  var NotSubmitted = function NotSubmitted(_ref2) {
    var regularOrderingDisplayDeadline = _ref2.regularOrderingDisplayDeadline,
        _ref2$numberTakingExa = _ref2.numberTakingExam,
        numberTakingExam = _ref2$numberTakingExa === void 0 ? 0 : _ref2$numberTakingExa,
        _ref2$allowedToOrder = _ref2.allowedToOrder,
        allowedToOrder = _ref2$allowedToOrder === void 0 ? false : _ref2$allowedToOrder;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, "Not submitted"), !allowedToOrder ? /*#__PURE__*/React.createElement("p", null, "You cannot submit your order until you ", /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/settings?scroll=participationFormPanel"
    }, /*#__PURE__*/React.createElement("strong", null, "complete the participation form."))) : numberTakingExam > 0 ? /*#__PURE__*/React.createElement(SubmitOrderLink, {
      path: "/orders"
    }) : /*#__PURE__*/React.createElement("p", null, "You have no exams identified for your order."), /*#__PURE__*/React.createElement("div", {
      className: styles['order-deadline']
    }, "Order deadline: ", /*#__PURE__*/React.createElement("strong", null, formatDateTime(regularOrderingDisplayDeadline))));
  };

  var Submitted = function Submitted() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, "Submitted"), /*#__PURE__*/React.createElement("p", null, "You will be notified when your exam materials ship."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/orders/history"
    }, "View Order Details ", /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-east",
      "aria-hidden": true
    }))), /*#__PURE__*/React.createElement(ShipmentsLink, null));
  };

  var UnsubmittedChanges = function UnsubmittedChanges() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Unsubmitted Changes"), /*#__PURE__*/React.createElement("p", null, "You must submit before your changes are applied."), /*#__PURE__*/React.createElement(SubmitOrderLink, {
      path: "/orders/unsubmitted"
    }), /*#__PURE__*/React.createElement(ShipmentsLink, null));
  };

  var PanelBody = function PanelBody() {
    if (hasUnsubmittedChanges) return /*#__PURE__*/React.createElement(UnsubmittedChanges, props);
    if (isSubmitted) return /*#__PURE__*/React.createElement(Submitted, props);
    return /*#__PURE__*/React.createElement(NotSubmitted, props);
  };

  return /*#__PURE__*/React.createElement(Panel, {
    title: /*#__PURE__*/React.createElement(PanelHeader, props),
    panelClass: "".concat(styles['order-panel'], " ").concat(!isSubmitted || hasUnsubmittedChanges ? 'cb-panel-blue' : ''),
    body: /*#__PURE__*/React.createElement(PanelBody, props)
  });
});